import {
  ListBalance,
  QUERY_KEY_LIST_BONUS_BALANCE,
} from '~/features/Balance/ListBalance'
import { AdditionalBalanceHeading } from '~/entities/MainBalance/ui/AdditionalBalanceHeading'
import { pushFx } from '~/shared/lib/history'
import { PageContainer } from '~/shared/ui/PageContainer'
import { useRefreshPage } from './useRefreshPage'

export function ListBonusBalancePage() {
  const { refreshPage } = useRefreshPage()

  return (
    <PageContainer
      canBack
      onBack={() => pushFx('/')}
      title='Бонусный баланс'
      topContent={
        <AdditionalBalanceHeading
          balanceType='BY_BONUS'
          title='Бонусный баланс'
        />
      }
      onRefreshPage={refreshPage}
    >
      <ListBalance
        queryKey={QUERY_KEY_LIST_BONUS_BALANCE}
        balanceType='BY_BONUS'
      />
    </PageContainer>
  )
}
